import {
  GUEST_FEE_DISCOUNT_BUCKETS,
  MAX_REVIEW_MIN_LENGTH,
} from "../statsig.consts";
import type {
  GuestFeeDiscountBucket,
  StatsigParamValue,
} from "../statsig.types";

const getStatsigEnvironment = (): "development" | "staging" | "production" => {
  switch (window.PUBLIC_ENV.PS_ENV) {
    case "prod":
      return "production";
    case "beta":
      return "staging";
    default:
      return "development";
  }
};

/**
 * Normalizes the Statsig guest fee experiment parameter into the backend contract.
 */
const normalizeGuestFeeDiscountBucket = (
  value: StatsigParamValue,
): GuestFeeDiscountBucket => {
  if (
    typeof value === "string" &&
    GUEST_FEE_DISCOUNT_BUCKETS.includes(value as GuestFeeDiscountBucket)
  ) {
    return value as GuestFeeDiscountBucket;
  }

  return "full";
};

/**
 * Normalizes the review-length experiment parameter into a character minimum.
 */
const normalizeReviewMinLength = (value: StatsigParamValue): number => {
  const minLength =
    typeof value === "number"
      ? value
      : typeof value === "string" && value.trim() !== ""
        ? Number(value)
        : NaN;

  if (
    !Number.isInteger(minLength) ||
    minLength <= 0 ||
    minLength > MAX_REVIEW_MIN_LENGTH
  ) {
    return 0;
  }

  return minLength;
};

export {
  getStatsigEnvironment,
  type GuestFeeDiscountBucket,
  normalizeGuestFeeDiscountBucket,
  normalizeReviewMinLength,
};
